import { render } from "./PaperUpload.vue?vue&type=template&id=81d21e32&scoped=true"
import script from "./PaperUpload.vue?vue&type=script&lang=js"
export * from "./PaperUpload.vue?vue&type=script&lang=js"

import "./PaperUpload.vue?vue&type=style&index=0&id=81d21e32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d21e32"]])

export default __exports__